import React from "react";
import { withState } from "recompose";
import { useMutation } from "react-apollo";

import dynamicHOC from "dynamic/hocs/Dynamic";
import CREATE_CUSTOMER_SUPPORT from "graphql/createCustomerSupport";

import ContactForm from "./ContactForm";
import ErrorMessage from "./ErrorMessage";
import SuccessMessage from "./SuccessMessage";

const FAQContactForm = ({ status, setStatus }) => {
  const [contactCustomerSupport] = useMutation(CREATE_CUSTOMER_SUPPORT);

  const handleSubmit = (values, resetForm) => {
    contactCustomerSupport({
      variables: {
        params: {
          company: values.company,
          email: values.email,
          firstName: values.firstname,
          lastName: values.lastname,
          message: values.message,
          phone: values.phoneNumber,
          salutation: values.salutation,
        },
        subscribeToNewsletter: values.subscribeToNewsletter,
      },
    })
      .then(() => {
        setStatus("submitted");
        resetForm();
      })
      .catch(() => {
        setStatus("error");
      });
  };

  return (
    <>
      <ContactForm
        onSubmit={
          (values, { resetForm }) => handleSubmit(values, resetForm)
        }
        defaultMessage=""
      />
      {status === "submitted" && (
        <div className="mt-2 mx-4 md:mx-0">
          <SuccessMessage>
            Vielen Dank! Ihre Anfrage wurde erfolgreich übermittelt. Wir melden
            uns so schnell wie möglich.
          </SuccessMessage>
        </div>
      )}
      {status === "error" && (
        <div className="mt-2 mx-4 md:mx-0">
          <ErrorMessage>
            Es gab einen Fehler bei der Übermittlung Ihrer Anfrage. Bitte
            versuchen Sie es später erneut.
          </ErrorMessage>
        </div>
      )}
    </>
  );
};

export default withState("status", "setStatus", "")(dynamicHOC(FAQContactForm, false));
